import { ReactNode, CSSProperties } from 'react'
import Styles from './ColorPicker.module.scss'
import { HexAlphaColorPicker } from 'react-colorful'
import { DropdownTrigger } from 'components/DropdownTrigger/DropdownTrigger'
import { Pressable } from '@react-aria/interactions'

const DEFAULT_COLORS = [
  Styles.navy30,
  Styles.blue30,
  Styles.green30,
  Styles.gold30,
  Styles.orange30,
  Styles.red30,
  Styles.pink30,
  Styles.violet30,
  Styles.gray30,
]

interface Props {
  ariaLabel?: string
  color: string | null
  colors?: string[]
  children: ReactNode
  disabled?: boolean
  onChange: (color: string | null) => void
}

export const ColorPicker = ({ ariaLabel, children, color, colors = DEFAULT_COLORS, disabled, onChange }: Props) => {
  return (
    <DropdownTrigger popoverClassName={Styles.popover}>
      <Pressable>
        <button aria-label={ariaLabel} disabled={disabled} type="button">
          {children}
        </button>
      </Pressable>
      {(_) => (
        <div className={Styles.picker}>
          <HexAlphaColorPicker color={color || undefined} onChange={onChange} />
          <div className={Styles.swatches}>
            {colors.map((color) => (
              <button
                key={color}
                className={Styles.swatch}
                style={{ '--swatch-color': color } as CSSProperties}
                type="button"
                onClick={() => onChange(color)}
              />
            ))}
          </div>
        </div>
      )}
    </DropdownTrigger>
  )
}
